import { makeStyles } from '@material-ui/core';
import logo from './logo.png';

const useStyles = makeStyles({
  img: {
    display: 'block',
    height: 40,
    width: 40,
    objectFit: 'cover',
    objectPosition: 'center top',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();
  return <img className={classes.img} src={logo} alt="CHI Backstage" />;
};
